import React from 'react'
import PropTypes from 'prop-types'

import { ReactComponent as Delete } from '../../shared/icons/delete.svg'
import style from './FieldList.module.scss'

const FieldList = ({ field, listItems, onDelItem }) => {
	return(
		<div className={style.root}>
			<ul>
				{listItems.map(item => (
					<li key={item.id}>
						<span>{item.value}</span>
						<button
							onClick={(e) => {
								e.preventDefault()
								onDelItem({ field: field, value: item.id })
							}}
							className={style.btnDel}
						><Delete /></button>
					</li>)
				)}
			</ul>
		</div>
	)
}

FieldList.propTypes = {
	field: PropTypes.string.isRequired,
	onDelItem: PropTypes.func.isRequired,
	listItems: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
		value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
	}))
}

FieldList.defaultProps = {
	listItems: []
}

export default FieldList
